const DEFAULT_MAX_PLACEHOLDER_LENGTH = 90;

export function truncatePlaceholder(
	text: string,
	maxLength: number = DEFAULT_MAX_PLACEHOLDER_LENGTH,
): string {
	if (text.length <= maxLength) {
		return text;
	}

	const truncated = text.substring(0, maxLength);
	const lastSpaceIndex = truncated.lastIndexOf(' ');
	const breakPoint = lastSpaceIndex > 0 ? lastSpaceIndex : maxLength;

	return text.substring(0, breakPoint) + '...';
}
